export const placeholders = {
  clickToSelectFileOrDropHere: "Click to select a file or drag here",
  selectCountry: "Select country",
  selectStateProvince: "Select State/Province",
};
